import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";

import { ServiceDetailsShape } from "../../policies/proptypes";

class ServiceDetails extends Component {
  static formatDate = (utc, locale) => {
    if (!utc) {
      return "N/A";
    }

    const [day, time] = new Date(utc).toLocaleString(locale).split(", ");
    return (
      <Fragment>
        <div>{day}</div>
        <div className="p-muted-text">{time}</div>
      </Fragment>
    );
  };

  getStatusDetails = () => {
    const { service } = this.props;
    const { pending, product } = service;
    let statusText = "Active";
    let inactive;

    if (pending) {
      statusText = `Not configured${product ? ` with ${product.name}` : ""}`;
    }

    if (!pending && !service.last_contact) {
      inactive = true;
      statusText = "Ready: Not yet contacted";
    }

    if (service.last_contact && service.last_contact.$date) {
      const now = Date.now();
      if ((now - service.last_contact.$date) / 3600000 > 2) {
        inactive = true;
        statusText = "No activity for over 2 hours";
      }
    }

    return (
      <Fragment>
        <i
          className={`p-icon--${pending || inactive ? "pending" : "active"}`}
        />
        <span className="p-icon__text">{statusText}</span>
      </Fragment>
    );
  };

  getRegistrationOptions = () => {
    const { service, openInstructions } = this.props;
    const { credentials, pending, product } = service;
    let text;

    if (product && product.label === "maas") {
      text = "View CLI instructions";
    }
    if (product && product.label === "lxd") {
      if (credentials) {
        text = "View credentials";
      } else if (pending) {
        text = "Generate credentials";
      } else {
        text = "Regenerate credentials";
      }
    }

    return (
      text && (
        <button
          type="button"
          className="p-button--link"
          onClick={() => openInstructions(service)}
        >
          {text}
        </button>
      )
    );
  };

  render = () => {
    const { openInstructions, service } = this.props;

    return (
      <div style={{ gridArea: "service-details", overflowY: "auto" }}>
        <div className="l-services__details">
          <div className="l-services__column" style={{ flex: "20" }}>
            <div className="l-services__column-header">
              <span className="p-muted-heading u-no-margin--bottom">
                Last activity
              </span>
            </div>
            <div className="l-services__column-panel">
              {service && (
                <span>
                  {service.last_contact
                    ? this.constructor.formatDate(service.last_contact.$date)
                    : "N/A"}
                </span>
              )}
            </div>
          </div>
          <div className="l-services__column" style={{ flex: "40" }}>
            <div className="l-services__column-header">
              <span className="p-muted-heading u-no-margin--bottom">
                Description
              </span>
            </div>
            <div className="l-services__column-panel">
              {service && <span>{service.description}</span>}
            </div>
          </div>
          <div className="l-services__column" style={{ flex: "25" }}>
            <div className="l-services__column-header">
              <span className="p-muted-heading u-no-margin--bottom">
                Status
              </span>
            </div>
            <div className="l-services__column-panel">
              {service && this.getStatusDetails()}
            </div>
          </div>
          {openInstructions && (
            <div className="l-services__column" style={{ flex: "25" }}>
              <div className="l-services__column-header">
                <span className="p-muted-heading u-no-margin--bottom">
                  Registration
                </span>
              </div>
              <div className="l-services__column-panel">
                {service && this.getRegistrationOptions()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
}

ServiceDetails.propTypes = {
  openInstructions: PropTypes.func,
  service: ServiceDetailsShape
};

ServiceDetails.defaultProps = {
  openInstructions: undefined,
  service: undefined
};

export default ServiceDetails;
